import { Dialog } from '@mui/material'
import { useState } from 'react'
import styled from 'styled-components'

type TProps = {
  text: string
  absolute?: boolean
  style?: React.CSSProperties
}

export default function Info({ text, absolute, style }: TProps) {
  const [showPopup, setShowPopup] = useState<boolean>(false)

  const stopPropagation = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const openPopUp = (e: React.MouseEvent<HTMLDivElement>) => {
    stopPropagation(e)
    setShowPopup(true)
  }

  const closePopUp = (e: React.MouseEvent) => {
    stopPropagation(e)
    setShowPopup(false)
  }

  return (
    <>
      <Container onClick={openPopUp} absolute={!!absolute} style={style}>
        ?
      </Container>
      <Dialog open={showPopup} onClose={closePopUp}>
        <Text style={{ marginTop: 20 }}>
          {text
            .replace(/\\n/g, '\n')
            .split('\n')
            .map((line, i) => (
              <span key={i}>
                {line}
                <br />
              </span>
            ))}
        </Text>
      </Dialog>
    </>
  )
}

const Container = styled.div<{ absolute: boolean }>`
  display: flex;
  border-radius: 10px;
  height: 20px;
  width: 20px;
  background-color: #eaeaea;
  justify-content: center;
  align-items: center;
  ${({ absolute }) => absolute && 'position:absolute;top:-6px;right:-10px;'}
  cursor:pointer;
  font-weight: 500;
  font-size: 15px;
  color: #000000;

  &:hover {
    background-color: #1edb97;
    color: white;
  }
`

const Text = styled.p`
  padding: 30px;
  font-family: Roboto;
  font-size: 14px;
  line-height: 1.5;
`
